export default "__VITE_ASSET__BsLkh6js__"